var _effectorFileName = "/src/page-content/for-companies/components/our-offers/our-offers.tsx";
import { Article } from '@/shared/components/article';
import { Table, TableBody, TableCaption, TableCell, TableFooter, TableHead, TableHeader, TableRow } from '@/shared/components/ui/table';
import { OUR_OFFERS } from './constants/company-offers';
export const OurOffers = () => {
  return <Article>
      <h2 className="mb-4 header-h2 sm:mb-8">Наше предложение</h2>

      <Table className="sm:min-w-auto w-full min-w-[480px]">
        <TableCaption>*Возможна оплата в различных валютах</TableCaption>

        <TableHeader>
          <TableRow>
            <TableHead className="min-w-40">Формат занятий</TableHead>
            <TableHead className="min-w-36">Длительность урока</TableHead>
            <TableHead className="min-w-32">Количество студентов</TableHead>
            <TableHead className="min-w-24 text-right">Стоимость (&#8381;)*</TableHead>
          </TableRow>
        </TableHeader>

        <TableBody>
          {OUR_OFFERS.map((offer, index) => <TableRow key={index} className="text-sm sm:text-base">
              <TableCell className="max-w-20 overflow-hidden text-ellipsis whitespace-nowrap font-medium">
                {offer.type}
              </TableCell>

              <TableCell>{offer.duration}</TableCell>
              <TableCell className="max-w-xs">{offer.studentsNumber}</TableCell>
              <TableCell className="text-right font-semibold">{offer.price} &#8381;</TableCell>
            </TableRow>)}
        </TableBody>

        <TableFooter>
          <TableRow>
            <TableCell colSpan={1}>Промокод для сотрудников компании:</TableCell>
            <TableCell colSpan={3}>10% скидка на&nbsp;все занятия (только для индивидуальных студентов).</TableCell>
          </TableRow>
        </TableFooter>
      </Table>
    </Article>;
};